<template>
  <TransactionListTemplate
    :screenConfig="setScreenConfig"
    :rowClick="rowClickCallBack"
    :persistenceKey="'supplier-list'"
  />
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";

import TransactionListTemplate from "../../templates/transaction-list";
import { FeatureStorage } from "../../_services/storage";
import {
  SuppliersTabs,
  GetIndexByTabName,
} from "../../_models/tabdata/suppliers/suppliers-tabs";

export default {
  props: {},
  mixins: [RouteMixin, FormMixin],
  components: {
    TransactionListTemplate,
  },
  data() {
    return {};
  },
  computed: {
    setScreenConfig() {
      var config = {
        title: "Suppliers",
        exportFileName: "Suppliers List",
        selectedIndex: GetIndexByTabName("All"),
        tabs: SuppliersTabs,
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "SupplierList",
              filter: "",
              serverPaging: true,
              allowGrouping: false,
            },
            // rowSelect: {
            //   view: this,
            //   page: "supplier",
            //   mode: "review",
            //   idProperty: "Code",
            // },
            noDataMessage: {
              addNew: {
                class: "add-new",
                title: "No Suppliers",
                message: "Get Started, Add a Supplier",
              },
            },
          },

          toolbar: {
            search: false,
            columnChooser: true,
            export: true,
            openFilter: true,
            expand: false,
            customButtons: [
              {
                icon: "plus",
                label: "Add New",
                route: "/supplier/create",
                clickAction: {},
                buttonLocation: "left",
              },
            ],
          },
          columns: [
            {
              screenField: "Supplier",
              gridDataField: "Name",
              cellTemplateRecord: {
                primary: [
                  {
                    dataField: "Name",
                  },
                ],
                secondary: [
                  {
                    dataField: "Code",
                  },
                ],
              },
              exportFields: [
                {
                  dataField: "Code",
                  label: "Supplier Code",
                },
                {
                  dataField: "Name",
                  label: "Supplier Name",
                },
              ],
              sortOrder: "asc",
              sortIndex: 0,
              fixed: true,
              fixedPosition: "left",
              allowHiding: false,
              filterIndex: 0,
              type: "Text",
              filterDataField: "SupplierSearchText"
            },
            {
              screenField: "SupplierType",
              label: "Type",
              gridDataField: "SupplierTypeDescription",
              filterIndex: 2,
              filterLabel: "Type",
              filterDataField: "SupplierTypeCode",
            },
            {
              screenField: "Currency",
              cellTemplate: null,
              cellTemplateRecord: undefined,
              gridDataField: "CurrencyCode",
              exportFields: undefined,
              width: 120,
              minWidth: 120,
              filterIndex: 3,
            },
            {
              screenField: "Country",
              width: 150,
              minWidth: 150,
            },
            {
              screenField: "State",
              width: 120,
              minWidth: 120,
            },

            {
              screenField: "Abn",
              label: "Abn",
              gridDataField: "Abn",
              visible: false,
            },
            {
              screenField: "Terms",
              width: 120,
              minWidth: 120,
              visible: false,
            },
            {
              screenField: "TermCalculation",
              width: 120,
              minWidth: 120,
              visible: false,
              filterIndex: 4,
              filterLabel: "Terms Method"
            },
            {
              screenField: "Product",
              gridDataField: "ProductCodeList",
              filterDataField: "ProductCodeList",
              label: "Product",
              visible: false,
              showInColumnChooser: false,
              filterIndex: 5,
              filterOperator: "contains",
            },
            {
              screenField: "Status",
              gridDataField: "Inactive",
              gridLabel: "Status",
              filterIndex: 1,
              filterDefaultValue: ["N"],
            },

            {
              screenField: "GridRecordEllipsisMenu",
              cssClass: "padding-7",
              allowSearch: false,
              ellipsisMenu: {
                itemAction: (data) => {
                  var items = [
                    {
                      menuText: "Pay",
                      data: data,
                      clickAction: this.goToPay,
                      // visible:
                      // data.data.Status != "Paid" ? true : false,
                      disabled:
                        data.data.Inactive == "N" &&
                        FeatureStorage.checkPermission("CashPayment", "create")
                          ? false
                          : true,
                    },
                    {
                      menuText: "Invoice",
                      data: data,
                      clickAction: this.goToSupplierInvoice,
                      disabled: FeatureStorage.checkPermission(
                        "SupplierInvoice",
                        "create"
                      )
                        ? false
                        : true,
                    },
                  ];

                  return items;
                },
                keyExpr: "menuText",
                displayExpr: "menuText",
              },
              // makeDisabled: (data) => {
              //   if (
              //     data.data.Inactive == "N" ||
              //     FeatureStorage.checkPermission("SupplierInvoice", "create")
              //   ) {
              //     return true;
              //   } else return false;
              // },
            },
          ],
        },
      };

      return config;
    },
  },
  methods: {
    goToSupplierInvoice(e) {
      this.$router.push({
        path: "/supplier-invoice/create",
        query: {
          from: "supplier",
          SUP_ID: JSON.stringify(e.Code),
        },
      });
    },
    goToPay(e) {
      this.$router.push({
        path: `supplier-payment/create/${e.Code}`,
        query: {
          from: "/supplier",
          SUP_ID: encodeURI(JSON.stringify(e.Code)),
        },
      });
    },
    rowClickCallBack(e) {
      if (
        e.rowType == "data" &&
        e.column.screenField != "Status" &&
        e.column.screenField != "GridRecordEllipsisMenu"
      ) {
        this.onRowClicked(e, {
          view: this,
          page: "supplier",
          mode: "review",
          idProperty: "Code",
        });
      }
    },
  },

  created() {},
};
</script>

<style lang="scss"></style>
